import type { IpSearchOnboardingSettingsV1 } from '@telecom/shared/domain/user-settings';

/** 后端状态写入的一致性策略。 */
export type OnboardingStateUpdateMode = 'required' | 'optimistic';

/** 统一读取和更新账号级 IP Search onboarding 后端状态。 */
export interface OnboardingStateService {
    /**
     * 获取当前账号的 onboarding 状态。
     * @param accountId 当前登录账号的稳定 ID
     */
    getState(accountId: string): Promise<IpSearchOnboardingSettingsV1>;

    /**
     * 合并并更新当前账号的 onboarding 状态。
     * @param accountId 当前登录账号的稳定 ID
     * @param patch 待合并的状态字段
     * @param mode required 要求后端成功后生效；optimistic 立即在当前会话生效
     */
    updateState(
        accountId: string,
        patch: Partial<IpSearchOnboardingSettingsV1>,
        mode: OnboardingStateUpdateMode,
    ): Promise<void>;

    /**
     * 将当前账号重置为可重新展示入口及全部报告引导的状态。
     * @param accountId 当前登录账号的稳定 ID
     */
    resetState(accountId: string): Promise<void>;
}

export const OnboardingStateService = Symbol('OnboardingStateService');
